import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  mainContainer: {
    display: "flex",
    alignItems: "center",
    gap: "16px"
  },
  innerContainer: {
    display: "flex",
    alignItems: "center",
    gap: "1px"
  },
  typography: {
    color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "143%", /* 20.02px */
    letterSpacing: "0.15px",
  },
  buttonGroup: {
    border: "1px solid #ccc",
    borderRadius: "4px",
    display: "inline-flex",
  },
  buttonLOW: {
    color: "#1B5E20",
  },
  buttonMEDIUM: {
    color: "#E65100",
  },
  buttonHIGH: {
    color: "#C62828",
  },
  buttonANY: {
    color: "#1976d2",
  },
  buttonActiveHIGH: {
    backgroundColor: "#FDEDED",
  },
  buttonActiveLOW: {
    backgroundColor: "#EDF7ED",
  },
  buttonActiveANY: {
    backgroundColor: "rgba(25,118,210,0.1)",
  },
  buttonActiveMEDIUM: {
    backgroundColor: "#FFF4E5",
  },
  buttonTypography: {
    fontFamily: "Inter",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "22px", /* 169.231% */
    letterSpacing: "0.46px",
    padding: "4px 10px !important",
  },
}));
